//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { EthAddr, TxHash } from '@shared/SchemaTypes'
import { Contract, Signer } from 'ethers'

import { ActivityEnum } from '@shared/Enums'

import { logOT } from '@shared/loggingShared'

import { PoolAbi, PoolAccessControlAbi } from '@shared/Abis'
import { ProviderWritable } from '@shared/SchemaTypes'

import { txUUID, wsServerActionPoolTX, wsServerActionPoolTXRequest } from '@shared/WsServerActions'

export async function removePoolParticipation(
  webSocket: WebSocket | undefined,
  poolAdminSigner: Signer,
  poolAddr: EthAddr,
  lenderAddr: EthAddr,
  chainConfigurationName: string
): Promise<boolean> {
  const uuid = txUUID()

  webSocket?.send(
    wsServerActionPoolTXRequest(ActivityEnum.POOL_REMOVE_PARTICIPATION, poolAddr, uuid, chainConfigurationName)
  )
  const providerWritable = poolAdminSigner.provider as ProviderWritable
  const PoolContract = new Contract(poolAddr, PoolAbi, providerWritable)
  const poolAccessControlAddr = await PoolContract.poolAccessControl()

  logOT.info('Attempting to remove pool participation', !!webSocket, poolAccessControlAddr, lenderAddr)
  const poolAccessControl = new Contract(poolAccessControlAddr, PoolAccessControlAbi, poolAdminSigner)

  const tx2 = await poolAccessControl.removeParticipant(lenderAddr)

  webSocket?.send(
    wsServerActionPoolTX(
      ActivityEnum.POOL_REMOVE_PARTICIPATION,
      poolAddr,
      uuid,
      tx2.hash as TxHash,
      chainConfigurationName,
      { lenderAddr }
    )
  )
  await tx2.wait()

  const isAllowed = await poolAccessControl.isAllowed(lenderAddr)
  logOT.info('Successfully removed pool participation', !!webSocket, poolAddr, lenderAddr, isAllowed)
  return !isAllowed // Return true if removal was successful (isAllowed should be false)
}
